import Api from '@/services/api'

export default {
  async getCenarios (idUsuario) {
    if (!idUsuario) { return }

    const response = await new Api().get(
      'Cenario/obterCenariosUsuario/' + idUsuario
    )

    if (!response) { return false }

    if (!response.dados) { return false }

    return response.dados
  },
  async deleteCenario (id) {
    if (!id) { return false }

    const response = await new Api().get(
      'Cenario/excluirCenariosUsuario/' + id
    )

    if (!response) { return false }

    return true
  }
}
